import { SelectCurrentValue, SelectOption, SelectOptions, SelectWrapper } from './styles';
import { useSelect } from 'downshift';

// import { useEffect } from 'react';

export interface Option {
	value: string | number;
	label: string;
}
interface Props {
	value: string;
	onChange: (value: string) => void;
	options: Option[];
	id?: string;
}
export default function Select({ value, onChange, options, id }: Props) {
	const selectedOption = options.find(option => String(option.value) === value) || null;

	const {
		isOpen,
		selectedItem,
		getToggleButtonProps,
		getMenuProps,
		highlightedIndex,
		getItemProps
	} = useSelect({
		items: options,
		selectedItem: selectedOption,
		onSelectedItemChange: ({ selectedItem: newSelectedItem }) =>
			onChange(String(newSelectedItem?.value || ''))
	});

	// useEffect(() => {
	// 	if (isOpen) {
	// 		// Wait for next tick to ensure DOM is updated
	// 		const id = setTimeout(() => {
	// 			if (isOpen) {
	// 				debugger;
	// 			}
	// 		}, 0);
	// 		return () => clearTimeout(id);
	// 	}
	// }, [isOpen]);

	return (
		<SelectWrapper>
			<SelectCurrentValue {...getToggleButtonProps()}>
				{selectedItem?.label ?? 'Select an option'}
			</SelectCurrentValue>
			<SelectOptions {...getMenuProps()}>
				{isOpen &&
					options.map((item, index) => {
						return (
							<SelectOption
								key={`${item}${index}`}
								isHighlighted={highlightedIndex === index}
								{...getItemProps({
									item,
									index
								})}
							>
								{item.label}
							</SelectOption>
						);
					})}
			</SelectOptions>
		</SelectWrapper>
	);
}
